import { gql } from '@apollo/client'

import { SHOP_CART_FRAGMENT } from '../fragments'

export const GET_CURRENT_CART = gql`
  query CurrentCart {
    currentCart {
      ...ShopCart
    }
  }
  ${SHOP_CART_FRAGMENT}
`
